import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/Hero/Hero'
import Experience from '../../components/Experience/Experience'
import Gallery from '../../components/Gallery/Gallery'
import VideoSection from '../../components/VideoSection/VideoSection'
import Footer from '../../components/Footer/Footer'

const Home = () => {
  return (
    <div className='voyah-home'>
      <Navbar/>
      <Hero/>
      <Experience/>
      <Gallery/>
      <VideoSection/>
      <Footer/>
    </div>
  )
}

export default Home
